import { Pipe, PipeTransform } from '@angular/core';
import {PredicateModel} from '@app/core/model/filtering/predicate-model';
import {MetadataModel} from '@app/core/model/filtering/metadata-model';
import {AttributeType, FilterPredicate} from '@app/core/model/filtering/filter-predicate';
import {DataAttribute} from '@app/views/admin/application-settings/models/data-attribute.model';
import {FiltersListService} from '@app/views/admin/application-settings/components/filters/filters-list-wrapper/filters-list.service';

@Pipe({
    name: 'ngcFilterAllowedAttributePredicates'
})
export class FilterAllowedAttributePredicatesPipe implements PipeTransform {


    SCHOOL_ID = 'schoolId';
    GUID = 'guid';
    DATA_BROWSING_DENIED_FILTER_PREDICATES_LIST = new Map<string, FilterPredicate[]>([
        [this.SCHOOL_ID, [FilterPredicate.IS_EMPTY, FilterPredicate.IS_NOT_EMPTY, FilterPredicate.DOES_NOT_CONTAIN]],
        [this.GUID, [FilterPredicate.IS_EMPTY, FilterPredicate.IS_NOT_EMPTY, FilterPredicate.DOES_NOT_CONTAIN]]
    ]);

    transform(predicatesMetadata: MetadataModel[], attribute: DataAttribute): PredicateModel[] {
        let type: AttributeType = <AttributeType>(attribute && attribute.propertyTypeDenom ? attribute.propertyTypeDenom : AttributeType.STRING);
        type = this.isGuid(type) ? AttributeType.GUID : type;
        const allowedPredicatesMetadata = (predicatesMetadata || []).find(it => it.type === type)
            || (predicatesMetadata || []).find(it => it.type === AttributeType.STRING);

        if (attribute) {
            const isSchoolId = FiltersListService.checkIsSchoolIdSelected(attribute.propertyName);
            const isSchoolGuid = FiltersListService.checkIsGuidSelected(attribute.propertyName);
            if (isSchoolId || isSchoolGuid) {
                const attributePropertyName = isSchoolId ? this.SCHOOL_ID :
                    isSchoolGuid ? this.GUID : '';
                allowedPredicatesMetadata.predicates = allowedPredicatesMetadata.predicates.filter((predicate: PredicateModel) =>
                    !this.DATA_BROWSING_DENIED_FILTER_PREDICATES_LIST.get(attributePropertyName).includes(predicate.name)
                );
            }
        }

        return allowedPredicatesMetadata ? allowedPredicatesMetadata.predicates : [];
    }

    isGuid(type: string) {
        return type && (type.substr(-4) === 'Guid');
    }
}
